import type { VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";
import { DataTable } from "@/components/custom/table/data-table";
import { DataTableContent } from "@/components/custom/table/data-table-content";
import { DataTablePagination } from "@/components/custom/table/data-table-pagination";
import type { UserSource } from "../../types";
import { createUserSourceColumns } from "./columns";

export const UserSourcesTable = ({
  items,
  columnVisibility,
  onColumnVisibilityChange,
  gatewayCountMap,
  gatewaysIsPending,
  gatewaysIsError,
}: {
  items: UserSource[];
  columnVisibility?: VisibilityState;
  onColumnVisibilityChange?: (
    updater: VisibilityState | ((old: VisibilityState) => VisibilityState)
  ) => void;
  gatewayCountMap?: Record<string, number>;
  gatewaysIsPending?: boolean;
  gatewaysIsError?: boolean;
}) => {
  const columns = useMemo(
    () =>
      createUserSourceColumns({
        gatewayCountMap,
        gatewaysIsPending,
        gatewaysIsError,
      }),
    [gatewayCountMap, gatewaysIsPending, gatewaysIsError]
  );

  return (
    <DataTable
      className="space-y-4"
      columns={columns}
      columnVisibility={columnVisibility}
      data={items}
      defaultPageSize={5}
      getRowId={(row) => row.id}
      onColumnVisibilityChange={onColumnVisibilityChange}
    >
      <DataTableContent stickyColumnBg="background" />
      <DataTablePagination />
    </DataTable>
  );
};
